import { Card, CardContent, Typography } from '@material-ui/core'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Nonprofit } from '../../models'
import { useNonProfitCardStyles } from './non-profit-card.styles'
import { NonprofitCardImage } from './non-profit.components/non-profit.no-image-logo'

export const NonProfit: React.FC<Nonprofit> = (
  props: Nonprofit
): React.ReactElement => {
  const {
    name,
    externalId,
    description,
    nonprofitCategoryName,
    nonprofitCardUrl,
  } = props

  const classes = useNonProfitCardStyles()
  const { t } = useTranslation()

  const linkTo = nonprofitCardUrl
    ? nonprofitCardUrl
    : `/external/${externalId}?externalId=${externalId}`

  return (
    <Card>
      <CardContent className={classes.cardContent}>
        <Link
          to={linkTo}
          className={classes.link}
        >
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            {/* Nonprofit Card Image */}
            <NonprofitCardImage externalId={externalId} />

            <div className={classes.cardText}>
              <Typography
                align="left"
                variant="h6"
                component="h6"
                className={[
                  classes.nonprofitName,
                  classes.bold,
                  classes.cardName,
                ].join(' ')}
                title={name}
              >
                {name}
              </Typography>
              <div className={classes.cardCategoryLine}>
                <Typography
                  align="left"
                  variant="h6"
                  component="h6"
                  className={[
                    classes.bold,
                    classes.cardCategory,
                    classes.cardCategoryLabel,
                  ].join(' ')}
                  title={'categoryLabel'}
                >
                  {`${t('nonprofitCatalog.categoryLabel')}:`}
                </Typography>
                <Typography
                  align="left"
                  variant="h6"
                  component="h6"
                  className={[
                    classes.space,
                    classes.cardCategory,
                    classes.cardCategoryName,
                  ].join(' ')}
                  title={nonprofitCategoryName}
                >
                  {nonprofitCategoryName}
                </Typography>
              </div>
              <Typography
                align="left"
                gutterBottom
                variant="h6"
                component="h6"
                className={[
                  !description && classes.italicText,
                  classes.noDescription,
                  classes.multilineEllipsis,
                ].join(' ')}
                title={description}
              >
                {description
                  ? description
                  : t('nonprofitCatalog.noDescription')}
              </Typography>
            </div>
          </div>
        </Link>
      </CardContent>
    </Card>
  )
}
